import { $get, $post } from '@/utils/http';

const getUnread = (params = {}) => $get({ url: '/operation/smart/notify/unreadnum', params }); // 未读消息数

const getMsgList = (params = {}) => $get({ url: '/operation/smart/notify/list', params }); // 获取消息

const readMsg = (params = {}) => $post({ url: '/operation/smart/notify/read', params }); // 消息已读

export default {
  getUnread,
  getMsgList,
  readMsg,
};
